import { createApp } from 'vue'
import __t from "../../../../../helpers/translate";
import vue_helpers from "../../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import fmtDate from "../../../../../helpers/fmtDay";

import contragent_info from "./contragent_info.vue";

window.P_INFO= createApp({
    name : "P_INFO",
    id : "P_INFO",
    components : {
        contragent_info : contragent_info,
    }
})
    .mixin(fmtDate)
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

P_INFO.mount('#contragent_info');